<template>
  <div class="section">
    <div style="padding-top: 5px">
      <div class="preLatitudeRadar">
        <preLatitudeRadar :model="model" :result="result" />
      </div>
      <div class="bg1" style="width: 300px; margin: 185px 0 20px 455px">
        <p style="color: #2abdb8; font-weight: bold; padding: 25px 0 0 44px">
          领导能力
        </p>
        <p
          style="
            font-size: 10pt;
            padding: 0 20px 10px 30px;
            margin-top: 20px;
            margin-left: 10px;
            line-height: 19.5px;
          "
        >
          {{ model.leadership }}
        </p>
      </div>

      <div class="bg1" style="width: 300px; margin: 25px 0 20px 455px">
        <p style="color: #2abdb8; font-weight: bold; padding: 25px 0 0 44px">
          社交能力
        </p>
        <p
          style="
            font-size: 10pt;
            padding: 0 20px 10px 30px;
            margin-top: 20px;
            margin-left: 10px;
            line-height: 19.5px;
          "
        >
          {{ model.sociability }}
        </p>
      </div>

      <div class="bg1" style="width: 300px; margin: 25px 0 20px 455px">
        <p style="color: #2abdb8; font-weight: bold; padding: 25px 0 0 44px">
          工作调整能力
        </p>
        <p
          style="
            font-size: 10pt;
            padding: 0 20px 10px 30px;
            margin-top: 20px;
            margin-left: 10px;
            line-height: 19.5px;
          "
        >
          {{ model.ability2AdjustWork }}
        </p>
      </div>
      <div class="bg1" style="width: 300px; margin: 25px 0 20px 455px">
        <p style="color: #2abdb8; font-weight: bold; padding: 25px 0 0 44px">
          情绪稳定
        </p>
        <p
          style="
            font-size: 10pt;
            padding: 0 20px 10px 30px;
            margin-top: 20px;
            margin-left: 10px;
            line-height: 19.5px;
          "
        >
          {{ model.emotionalStability }}
        </p>
      </div>

      <!-- <div style="width: 300px; margin: 115px 0 0 455px">
        <p
          style="
            font-size: 10pt;
            padding: 0 10px 10px 10px;
            line-height: 19.5px;
          "
        >
          {{ model.sociability }}
        </p>
      </div> -->
      <!-- <div style="width: 300px; margin: 115px 0 0 455px">
        <p style="font-size: 10pt; padding: 10px; line-height: 19.5px">
          {{ model.ability2AdjustWork }}
        </p>
      </div> -->
      <!-- <div style="width: 290px; margin: 133px 0 0 465px">
        <p style="font-size: 10pt; line-height: 19.5px">
          {{ model.emotionalStability }}
        </p>
      </div> -->
    </div>
  </div>
</template>

<script>
import preLatitudeRadar from "@/components/dataView/echarts/personality/preLatitudeRadar.vue";
export default {
  props: ["model", "result"],
  components: { preLatitudeRadar },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.section {
  page-break-before: always;
  page-break-after: always;
  page-break-inside: avoid;
  height: 1124px; //A4纸的高度像素
  background-size: 100% 100%;
  background-image: url("../../../../assets/images/personality/back-2.png");
  overflow: hidden;

  .preLatitudeRadar {
    width: 400px;
    margin-top: 170px;
    margin-left: 10px;
    float: left;
  }
  .bg1 {
    background-image: url("../../../../assets/images/personality/infoBack.png");
    background-size: 100% 100%;
    width: 300px;
    height: 203px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/report/three/personality/pageFive.vue